import * as z from 'zod/v4-mini';

const PaletteColorSchema = z.object({
	50: z.string(),
	100: z.string(),
	200: z.string(),
	300: z.string(),
	400: z.string(),
	500: z.string(),
	600: z.string(),
	700: z.string(),
	800: z.string(),
	850: z.optional(z.string()),
	900: z.string(),
	950: z.string(),
});

export const ThemeDefinitionSchema = z.object({
	name: z.string(),
	appearance: z.enum(['light', 'dark']),
	palette: z.object({
		primary: z.optional(PaletteColorSchema),
		neutral: z.optional(PaletteColorSchema),
		success: z.optional(PaletteColorSchema),
		warning: z.optional(PaletteColorSchema),
		error: z.optional(PaletteColorSchema),
		info: z.optional(PaletteColorSchema),
		orange: z.optional(PaletteColorSchema),
	}),
});

export type ThemeDefinition = z.infer<typeof ThemeDefinitionSchema>;

export function defineTheme(options: ThemeDefinition) {
	return ThemeDefinitionSchema.parse(options);
}
